import { useEffect, useState } from 'react';
import { Badge, Button, Card, Empty, Page, Spinner, api, brl, dateTime, km, rideStatusLabel, useAuth, BUILD_ID } from '@mobi/web';
import type { Ride } from '../useRide.js';

const TONE: Record<string, 'good' | 'bad' | 'neutral'> = {
  finished: 'good',
  cancelled: 'bad',
  no_drivers: 'neutral',
};

export function History() {
  const { user, logout } = useAuth();
  const [rides, setRides] = useState<Ride[] | null>(null);

  useEffect(() => {
    api<{ rides: Ride[] }>('/api/rides?limit=50')
      .then((r) => setRides(r.rides))
      .catch(() => setRides([]));
  }, []);

  return (
    <Page title="Suas viagens" subtitle={user?.name}>

        {!rides && (
          <div className="mt-8 grid place-items-center text-brand">
            <Spinner />
          </div>
        )}

        {rides?.length === 0 && (
          <Empty title="Nenhuma viagem ainda" hint="Sua primeira corrida aparece aqui." />
        )}

        <ul className="mt-4 space-y-3">
          {rides?.map((ride) => (
            <li key={ride.id}><Card className="p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="truncate font-medium">{ride.destination.address}</p>
                  <p className="truncate text-sm text-muted">de {ride.origin.address}</p>
                  <p className="mt-1 text-xs text-faint">
                    {dateTime(ride.timestamps.requestedAt)} · {km(ride.estimate.distanceMeters)}
                  </p>
                </div>
                <div className="shrink-0 text-right">
                  <p className="tabular font-semibold">
                    {brl(ride.finalFareCents ?? ride.estimate.fareCents)}
                  </p>
                  <div className="mt-1">
                    <Badge tone={TONE[ride.status] ?? 'neutral'}>
                      {rideStatusLabel(ride.status)}
                    </Badge>
                  </div>
                </div>
              </div>

              {ride.walletAppliedCents > 0 && (
                <p className="mt-2 text-xs text-good">
                  {brl(ride.walletAppliedCents)} abatidos da carteira
                </p>
              )}
              </Card></li>
          ))}
        </ul>

      <div className="mt-10">
        <Button variant="outline" full onClick={() => void logout()}>
          Sair da conta
        </Button>
        {/* Serve para saber, olhando a tela, se o aparelho pegou a versão
            nova — sem isso, "atualizou?" vira adivinhação. */}
        <p className="mt-4 text-center text-xs text-faint">versão {BUILD_ID}</p>
      </div>
    </Page>
  );
}
